import { BaseWidgetProps } from "../BaseProps";
import { WidgetNewsfeed_widgetNewsfeed$key } from "./__generated__/WidgetNewsfeed_widgetNewsfeed.graphql";
import { Platform } from "react-native";
import { NewsfeedWeb } from "./NewsfeedWeb";
import { NewsfeedNative } from "./NewsfeedNative";
import { graphql, useFragment } from "react-relay";
import { AHWidgetTitleLogo, AHWidgetTitleText, AHWidgetTitleWrapper, Box } from "arkh";

type Props = {
  widget: WidgetNewsfeed_widgetNewsfeed$key;
  mode?: "FOCUS" | "IDLE";
  interactive?: undefined | false;
} & BaseWidgetProps;

export const WidgetNewsfeed = (props: Props) => {
  const widget = useFragment(
    graphql`
      fragment WidgetNewsfeed_widgetNewsfeed on WidgetNewsfeed {
        title
        newsfeed {
          provider
        }
        ...NewsfeedNative_widgetNewsfeed
        ...NewsfeedWeb_widgetNewsfeed
      }
    `,
    props.widget
  );

  return (
    <Box
      color="surface"
      cornerRadius="medium"
      style={{ flex: 1, flexDirection: "column" }}
    >
      {widget.newsfeed.provider == "BOKAKLIPP" ? (
        <AHWidgetTitleLogo source={require("../WidgetList/BokaklippLogo.webp")} />
      ) : (
        <AHWidgetTitleWrapper>
          <AHWidgetTitleText>{widget.title}</AHWidgetTitleText>
        </AHWidgetTitleWrapper>
      )}
      <Box style={{ flex: 1 }} space="medium">
        <Box
          style={{ flex: 1 }}
          shadow="weak"
          cornerRadius="medium"
          color="surface"
        >
          {Platform.OS === "web" && props.idiom == "STATIC" ? (
            <NewsfeedWeb {...props} widget={widget} />
          ) : (
            <NewsfeedNative {...props} widget={widget} />
          )}
        </Box>
      </Box>
    </Box>
  );
};
